import http from './installation-risk-api.http';
import { InstallationRiskApi } from './installation-risk-api.types';

export default {
  /**
   * Get installed inverters for a project
   * GET /installations/projects/{project_id}/installed-inverters
   * @param projectId
   * @returns Installed inverters with serial numbers
   */
  getInstalledInverters: async (
    projectId: string,
  ): Promise<InstallationRiskApi.GetInstalledInvertersResponse> => {
    const { data } = await http.get<InstallationRiskApi.GetInstalledInvertersResponse>(
      `/installations/projects/${projectId}/installed-inverters`,
    );
    return data;
  },

  /**
   * Change inverter serial number(s) for a project
   * PATCH /installations/projects/{project_id}/installed-inverters
   * @param projectId
   * @param request
   * @returns Response with success message and validation info
   */
  changeInverterSerialNumber: async (
    projectId: string,
    request: InstallationRiskApi.ChangeInverterSerialNumberRequest,
  ): Promise<InstallationRiskApi.ChangeInverterSerialNumberResponse> => {
    const { data } = await http.patch<InstallationRiskApi.ChangeInverterSerialNumberResponse>(
      `/installations/projects/${projectId}/installed-inverters`,
      request,
    );
    return data;
  },
};

